import { createFileRoute, redirect } from "@tanstack/react-router";

// U15: the legacy QBO reconciliation page is absorbed by the /sources control
// room — sync controls live there, and the three-bucket triage is superseded by
// the /sources/review queue (U13). The old URL redirects.
export const Route = createFileRoute("/_authed/qbo-reconciliation")({
  beforeLoad: () => {
    throw redirect({ to: "/sources" });
  },
});
